const baseSettings = {
  dots: true,
  autoplay: true,
  autoplaySpeed: 4000,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  lazyLoad: true,
  arrows: true,
};

export const Settings = {
  ...baseSettings,
  responsive: [
    {
      breakpoint: 650,
      settings: {
        autoplay: false,
      },
    },
  ],
};
